import styled from 'styled-components';
import tw from 'tailwind-styled-components';
import React from 'react';

export const Container = tw.div`
  flex
  flex-wrap
  max-w-screen-lg
  justify-center
  m-auto
`;

export const Item = styled.div<{
  children?: React.ReactNode;
  key?: any;
  style?: React.CSSProperties;
}>`
  width: 304px;
  margin-right: 1rem;
  margin-left: 1rem;
  margin-bottom: 2rem;
`;
